import { Button } from "@/components/ui/button";

export function Pager({
  page,
  pageCount,
  onPage,
  summary,
  label,
}: {
  page: number;
  pageCount: number;
  onPage: (page: number) => void;
  summary: string;
  label: string;
}) {
  return (
    <div className="flex items-center justify-between px-2 pt-4">
      <div className="text-xs text-muted-foreground">{summary}</div>
      <div className="flex items-center space-x-4">
        <div className="text-xs font-medium">
          Page {page} of {pageCount}
        </div>
        <div className="flex items-center space-x-1">
          <Button
            variant="outline"
            className="h-7 w-7 p-0 text-xs"
            aria-label={`Go to previous ${label} page`}
            onClick={() => onPage(page - 1)}
            disabled={page <= 1}
          >
            ‹
          </Button>
          <Button
            variant="outline"
            className="h-7 w-7 p-0 text-xs"
            aria-label={`Go to next ${label} page`}
            onClick={() => onPage(page + 1)}
            disabled={page >= pageCount}
          >
            ›
          </Button>
        </div>
      </div>
    </div>
  );
}
